module.exports = __webpack_public_path__ + "img/search.a8de3044.svg";